import { inspectAllowedChars, inputParser } from './helpers';

export const telInputAction = (node, { handler, spaces, strictCountryCode }) => {
    let lastProcessedValue = node.value || '';
    let changeHandledThisCycle = false;

    const onInput = (event) => {
        if (event.isTrusted && node && node.contains(event.target)) {
            changeHandledThisCycle = true;
            const currentValue = event.target.value;
            const formattedInput = inputParser(currentValue, {
                parseCharacter: inspectAllowedChars,
                allowSpaces: spaces,
                disallowPlusSign: strictCountryCode
            });

            node.value = formattedInput;
            lastProcessedValue = formattedInput;
            handler(formattedInput);
        }
    };

    // Catch iOS autofill on blur (autofill events may not be trusted)
    const onBlur = () => {
        if (changeHandledThisCycle) {
            changeHandledThisCycle = false;
            lastProcessedValue = node.value;
            return;
        }
        const currentValue = node.value;
        if (currentValue !== lastProcessedValue) {
            const formattedInput = inputParser(currentValue, {
                parseCharacter: inspectAllowedChars,
                allowSpaces: spaces,
                disallowPlusSign: strictCountryCode
            });

            node.value = formattedInput;
            lastProcessedValue = formattedInput;
            handler(formattedInput);
        }
    };

    node.addEventListener('change', onInput, true);
    node.addEventListener('blur', onBlur, true);

    return {
        update(params) {
            if (params.value === null || params.value === '') {
                node.value = '';
                lastProcessedValue = '';
            }
        },
        destroy() {
            node.removeEventListener('change', onInput, true);
            node.removeEventListener('blur', onBlur, true);
        }
    };
};
